import React, {useState} from 'react';
import cn from 'classnames';

import Star from 'shared/ui/icons/Star';

import styles from './StarRating.module.scss';

interface IStarRatingProps {
    maxRating?: number;
    defaultValue?: number;
    // eslint-disable-next-line no-unused-vars
    onChange?: (rating: number) => void;
    readOnly?: boolean;
}

const StarRating: React.FC<IStarRatingProps> = ({
    maxRating = 5,
    defaultValue = 0,
    onChange,
    readOnly = false,
}) => {
    const [rating, setRating] = useState(defaultValue);
    const [hoverRating, setHoverRating] = useState(0);

    const handleClick = (value: number) => {
        if (readOnly) return;
        setRating(value);
        onChange?.(value);
    };

    return (
        <div className={styles.container}>
            {[...Array(maxRating)].map((_, index) => {
                const starValue = index + 1;
                const isFilled = starValue <= (hoverRating || rating);

                return (
                    <button
                        key={starValue}
                        type="button"
                        className={cn(styles.starButton, isFilled && styles.filledButton)}
                        onClick={() => handleClick(starValue)}
                        onMouseEnter={() => !readOnly && setHoverRating(starValue)}
                        onMouseLeave={() => !readOnly && setHoverRating(0)}
                        disabled={readOnly}
                        aria-label={`Оценка ${starValue} из ${maxRating}`}
                    >
                        <span
                            className={cn(styles.icon, isFilled && styles.filled)}
                        >
                            <Star />
                        </span>
                    </button>
                );
            })}
            <input type="hidden" name="rating" value={rating} />
        </div>
    );
};

export default StarRating;